import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { logger } from '../../utils/logger';

interface PublicRouteProps {
  children: React.ReactNode;
}

const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
  try {
    const { isAuthenticated, isLoading } = useAuth();

    if (isLoading) {
      return (
        <div className="min-h-screen bg-brand-bg-dark flex items-center justify-center">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-brand-accent mx-auto mb-4"></div>
            <p className="text-brand-text-muted">Carregando...</p>
          </div>
        </div>
      );
    }

    if (isAuthenticated) {
      return <Navigate to="/app/dashboard" replace />;
    }

    return <>{children}</>;
  } catch (error) {
    // Se houver erro ao usar useAuth (por exemplo, se não estiver dentro do AuthProvider),
    // apenas renderizar o children sem verificação de autenticação
    logger.warn('PublicRoute: Erro ao usar useAuth, renderizando sem verificação:', error);
    return <>{children}</>;
  }
};

export default PublicRoute;
